export const env = {
  AUTH_MSENTRAID_CLIENT_ID: import.meta.env.VITE_AUTH_MSENTRAID_CLIENT_ID as string,
  AUTH_MSENTRAID_TENANT_ID: import.meta.env.VITE_AUTH_MSENTRAID_TENANT_ID as string,
  AUTH_MSENTRAID_BFF_API_SCOPE: import.meta.env.VITE_AUTH_MSENTRAID_BFF_API_SCOPE as string,
  NEW_RELIC_ENABLED: import.meta.env.VITE_NEW_RELIC_ENABLED === 'true',
  NEW_RELIC_APPLICATION_ID: import.meta.env.VITE_NEW_RELIC_APPLICATION_ID as string,
  CONSOLE_DEBUG_ENABLED: import.meta.env.VITE_CONSOLE_DEBUG_ENABLED === 'true',
  OPERATIONS_TOOL_BACKEND_BASE_URL: import.meta.env.VITE_OPERATIONS_TOOL_BACKEND_BASE_URL as string,
}
